import axios from "axios";

export const getDataFromSSR = async (url,resolvedUrl="") => {
  try {
    const headers = {};
    if(resolvedUrl){
      headers["resolvedUrl"]=resolvedUrl
    }
    const response = await axios.get(url,{headers});
    let data = response?.data ?? null;
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
